import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-5bf7a1e7"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "contact",
  class: "mb-16"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "section-title" }, "Contacto", -1))
const _hoisted_3 = { class: "grid grid-cols-1 md:grid-cols-2 gap-10 items-start" }
const _hoisted_4 = { class: "text-subtle leading-relaxed max-w-[50ch]" }
const _hoisted_5 = { class: "space-y-5" }
const _hoisted_6 = { class: "font-mono-label text-[0.7rem] uppercase tracking-[0.14em] text-subtle mb-0.5" }
const _hoisted_7 = ["href"]
const _hoisted_8 = {
  key: 1,
  class: "text-ink font-semibold"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("p", { class: "font-mono-label text-[0.7rem] uppercase tracking-[0.14em] text-subtle mb-0.5" }, " LinkedIn "),
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://linkedin.com/in/juan-alonso-rodriguez-rivera-0b88291aa",
    target: "_blank",
    rel: "noopener",
    class: "text-ink font-semibold hover:text-indigo2 transition-colors break-all"
  }, " linkedin.com/in/juan-alonso-rodriguez-rivera-0b88291aa ")
], -1))

import { ref } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'Contacto',
  setup(__props) {

const descripcion = ref(
  'Estoy disponible para oportunidades laborales, proyectos freelance o simplemente para charlar sobre desarrollo backend. No dudes en contactarme a través de cualquiera de estos medios.',
);

const datosContacto = ref([
  {
    tipo: 'Email',
    valor: 'jonhalonsorodriguez@gmail.com',
    enlace: 'mailto:jonhalonsorodriguez@gmail.com',
  },
  {
    tipo: 'Teléfono',
    valor: '+503 7016 9190',
    enlace: 'tel:+50370169190',
  },
  {
    tipo: 'Ubicación',
    valor: 'San Salvador, El Salvador',
    enlace: null,
  },
]);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("p", _hoisted_4, _toDisplayString(descripcion.value), 1),
      _createElementVNode("div", _hoisted_5, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(datosContacto.value, (item, index) => {
          return (_openBlock(), _createElementBlock("div", { key: index }, [
            _createElementVNode("p", _hoisted_6, _toDisplayString(item.tipo), 1),
            (item.enlace)
              ? (_openBlock(), _createElementBlock("a", {
                  key: 0,
                  href: item.enlace,
                  class: "text-ink font-semibold hover:text-indigo2 transition-colors"
                }, _toDisplayString(item.valor), 9, _hoisted_7))
              : (_openBlock(), _createElementBlock("p", _hoisted_8, _toDisplayString(item.valor), 1))
          ]))
        }), 128)),
        _hoisted_9
      ])
    ])
  ]))
}
}

})